import { defineStore } from 'pinia';
import { documentPermissionsApiService } from 'src/services';
import type { dynamicObj } from 'src/pages/assets';

export const useGroupDropdownStore = defineStore('groups_dropdown', {
  state: () => ({
    group_list: [] as any,
    groups_loading: false,
    groups_loaded: false,
  }),
  actions: {
    async getGroups() {
      try {
        this.groups_loading = true;
        this.group_list = [];
        const response = await documentPermissionsApiService.getAll();

        if (!response) {
          throw response;
        }

        for (const [key, option] of Object.entries(response)) {
          const item = option as dynamicObj;
          this.group_list.push(
            Object.assign(
              {},
              {
                value: item.group_id,
                label: item.group_name,
              },
            ),
          );
        }

        this.groups_loaded = true;
      } catch (err) {
        logError(err);
      } finally {
        this.groups_loading = false;
      }
    },
  },
});
